import moment from "moment";
import { CommonConstants } from "src/app/common/common.constant";

export class HomeConstants {
  static readonly OrderType = {
    Procedure: 'Procedure',
    Component: 'Component',
    Supply: 'Supply',
  };

  static readonly OrderTypeArr = [
    {
      name: 'Procedure'
    },
    {
      name: 'Component'
    },
    {
      name: 'Supply'
    },

  ]
  static readonly BatchOrderTitle = 'Batch Order';
  static readonly selectMsg = "Select one or more timeslots to which procedure will be added"

  static readonly batchOrderErrorMsg = "There is a problem with the details entered. Please fix the errors.";
  static readonly batchOrderErrorMsg2 = "The selected procedure cannot be ordered from Batch Order. Please schedule it from Add Order."

  static readonly views = ['All Times', 'Order Times', 'Account Configuration Time'];
  static readonly heights = [
    {
      name:'cm',
      value: CommonConstants.uom.cm
    },
    {
      name: 'in',
      value: CommonConstants.uom.inch
    }
  ];
}
export class TimeValidator {
  timeFormat = 'HH:mm';
  error = true;

  validate(input) {
      if (moment(input, this.timeFormat, true).isValid()) {
          this.error = false;
      }
      return this.error;
  }

}
